export default "__VITE_ASSET__BqnKSYeW__"